module.exports = __webpack_public_path__ + "static/media/crm.4d62c92e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/crm.svg
// module id = 257
// module chunks = 0